import { SVGProps } from "react";

export const BusinessHandshakeDealIcon = ({
  color = "currentColor",
  size = 16,
  strokeWidth = 1,
  ...rest
}: SVGProps<SVGSVGElement> & { size?: number }) => {
  /* Render */
  const render = () => (
    <svg width={size} height={size} {...rest} fill="none" viewBox="0 0 24 24">
      <path
        fill="none"
        d="m13.874 16.5 -0.113 0.653 -1.709 0.295 -0.294 1.709 -1.709 0.294L6.097 15.5 3.5 15v1.5h-3v-9h3V9L6 8.5 9.618 7l1.896 1.896L13.132 7.5H15L18 9l2.5 0.5v-1h3v9h-3V16l-2 0.5h-4.626Z"
        strokeWidth={strokeWidth}
      ></path>
      <path
        fill={color}
        opacity={0.2}
        d="M23.5 10h-3v7.5h3V10Z"
        strokeWidth={strokeWidth}
      ></path>
      <path
        fill={color}
        opacity={0.2}
        d="M3.5 9h-3v7.5h3V9Z"
        strokeWidth={strokeWidth}
      ></path>
      <path
        stroke={color}
        vectorEffect="non-scaling-stroke"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M14.5 10.5 9.934 12 9 11.066 13.132 7.5H15L18 9l2.5 0.5V16l-2 0.5h-4.626"
        strokeWidth={strokeWidth}
      ></path>
      <path
        stroke={color}
        vectorEffect="non-scaling-stroke"
        strokeLinejoin="round"
        d="m3.5 15 2.597 0.5 3.952 3.951 1.709 -0.294 0.294 -1.709 1.709 -0.295 0.295 -1.709 1.708 -0.294 0.295 -1.709 -2.599 -2.599"
        strokeWidth={strokeWidth}
      ></path>
      <path
        stroke={color}
        vectorEffect="non-scaling-stroke"
        strokeLinejoin="round"
        d="M11.514 8.896 9.618 7 6 8.5 3.5 9"
        strokeWidth={strokeWidth}
      ></path>
      <path
        stroke={color}
        vectorEffect="non-scaling-stroke"
        strokeLinejoin="round"
        d="M3.5 7.5h-3v9h3v-9Z"
        strokeWidth={strokeWidth}
      ></path>
      <path
        stroke={color}
        vectorEffect="non-scaling-stroke"
        strokeLinejoin="round"
        d="M23.5 8.5h-3v9h3v-9Z"
        strokeWidth={strokeWidth}
      ></path>
    </svg>
  );
  return render();
};
